<template>
  <div v-show="show">
    <div>
      <div class="head">{{titlename}}</div>
      <div v-if="status">
        <div v-if="list.length">
          <table class="main">
            <thead>
            <tr>
              <th>排名</th>
              <th >玩家信息</th>
              <th >积分</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in list" :key="index">
              <td width="50">{{item.ranking}}</td>
<!--              <td>-->
<!--                <div class="middle">-->
<!--                  <img class="picture" :src="item.headurl">-->
<!--                  <p class="name">{{item.nickname}}</p>-->
<!--                </div>-->
<!--              </td>-->
              <td>{{item.Ftotal_plus}}</td>
            </tr>
            </tbody>
          </table>
          <div class="page">
            <div @click="next(1)">首页</div>
            <div @click="next(index-1)">上一页</div>
            <div>
              <select class="select" @change="next()" v-model="index">
                <option v-for="(item,index) in data" :key="index" :value="index+1">{{index+1}}/{{data.length}}</option>
              </select>
            </div>
            <div @click="next(index+1)">下一页</div>
            <div @click="next(data.length)">尾页</div>
          </div>
        </div>
        <div v-else class="empty">暂无排行榜信息</div>
        <div>
          <p class="ranking">我的排名</p>
          <table class="main">
            <tbody>
            <tr>
              <td width="50">{{oneself.ranking}}</td>
<!--              <td>-->
<!--                <div class="middle">-->
<!--                  <img class="picture" :src="oneself.headurl">-->
<!--                  <p class="name">{{oneself.nickname}}</p>-->
<!--                </div>-->
<!--              </td>-->
              <td>{{oneself.integral}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="quit" v-else v-html="quittext" />
      <p class="foot" v-html="explain"/>
    </div>
  </div>
</template>
<script>
import '../../assets/css/reset.css';
import bus from '../../../bus';
import axios from 'axios'
export default {
	name: 'h5-ankingList',
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			titlename: '标题名称',
			explain: '活动说明',
			quittext: '未登录文案',
			integralquery: '排行榜查询',
			ranking: '我的排名查询',
			integral: '我的积分查询',
			showtype: '展示(1安卓,0 IOS)'
		}
	},
	props: {
		titlename: {
			type: String,
			default: '标题'
		},
		explain: {
			type: String,
			default: '活动说明'
		},
		quittext: {
			type: String,
			default: '登录绑定后可查看排名'
		},
		integralquery: {
			type: Array,
			default: () =>
				[
					{
						h5Action: {
							class: 'action',
							title: '查询',
							type: 'no',
							value: ''
						}
					}
				]
		},
		ranking: {
			type: Array,
			default: () =>
				[
					{
						h5Action: {
							class: 'action',
							title: '查询',
							type: 'no',
							value: ''
						}
					}
				]
		},
		integral: {
			type: Array,
			default: () =>
				[
					{
						h5Action: {
							class: 'action',
							title: '查询',
							type: 'no',
							value: ''
						}
					}
				]
		},
		showtype: {
			type: String,
			default: ''
		}
	},
	computed: {},
	data () {
		return {
			show: true,
			data: [],
			list: [],
			index: 1,
			oneself: {},
			status: false
		};
	},
	mounted () {
		bus.$on('showtype', val => {
			this.show = val === this.showtype;
		});
		bus.$on('giftReceivedStatus', isGetedh5 => {
			this.query();
			this.status = true;
		});
	},
	methods: {
		async query () {
			const [{h5Action: { value }} = {}] = this.integralquery;
			const {gameCode} = this.$actConfig;
			if (value) {
				try {
					const {jData: {all_ranknum = []}} = await this.$doAction('ame', value, {sServiceType: gameCode});
					const data = all_ranknum.map((item, index) => {
						return {...item, ranking: index + 1}
					});
					for (var i = 0; i < data.length; i += 10) {
						this.data.push({list: data.slice(i, i + 10)})
					}
					this.get();
					this.data.length && this.next(1);
				} catch (e) {
					console.log(e)
					alert(e.sMsg)
				}
			}
		},
		async get () {
			const [{h5Action: { value }} = {}] = this.ranking;
			const [{h5Action: { value: id }} = {}] = this.integral;
			const {gameCode} = this.$actConfig;
			try {
				const {jData: {personal_ranknum = '未上榜'}} = await this.$doAction('ame', value, {sServiceType: gameCode});
				const {res: {sOutValue1 = '0'}} = await this.$doAction('ame', id, {sServiceType: gameCode});
				// 获取头像帐号暂时取消
				// const {data: {data}} = await axios.get('https://wang.xinyue.qq.com/api/headurl/update');
				// this.oneself = {ranking: personal_ranknum, integral: sOutValue1, ...data}
				this.oneself = {ranking: personal_ranknum, integral: sOutValue1}
			} catch (e) {
				console.log(e);
				alert('玩家排名信息获取失败')
			}
		},
		async next (val) {
			if (val > this.data.length) {
				alert('已经是最后一页')
			} else if (val < 1) {
				alert('已经是第一页')
			} else {
				this.index = val || this.index;
				this.list = this.data[this.index - 1].list;
				// try {
				// 	const openids = this.list.map(item => {
				// 		return item.Fuin;
				// 	})
				// 	const {data: {data}} = await axios.get('https://wang.xinyue.qq.com/api/headurl/list', {params: {openids: openids.join()}})
				// 	this.list = this.list.map(item => {
				// 		return {...item, ...JSON.parse(data[item.Fuin])};
				// 	})
				// } catch (e) {
				// 	console.log(e)
				// 	alert('排行榜头像昵称获取失败')
				// }
			}
		}
	},
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/common";
.head{
  margin:.2rem auto;
  font-size: .24rem;
}
.ranking{
  text-align: left;
  margin-left: .3rem;
}
.main{
  width: 100%;
  .middle{
    display: flex;
    justify-content: center;
    margin-top: .2rem;
    .picture{
      height: .8rem;
      width: .8rem;
      display: flex;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
    .name{
      margin:.1rem 0 0 .2rem;
      width: 2rem;
      text-align: left;
    }
  }
}
.page{
  display: flex;
  justify-content: space-around;
  margin:.2rem auto;
  height: 1rem;
  line-height: 1rem;
}
.foot{
  text-align: left;
  margin:.2rem 0 0 .3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/localCom/ankingList.vue